import { HdsCardContainer } from '@hashicorp/design-system-components/components';

const Card = <template>
  <HdsCardContainer
    @level="mid"
    @hasBorder="true"
    class="projectsDashboard__card"
    ...attributes
  >
    <div class="projectsDashboard__cardTitle">
      {{yield to="header"}}
    </div>
    <div class="projectsDashboard__cardBody">
      {{yield to="body"}}
    </div>
    <div class="projectsDashboard__cardFooter">
      {{yield to="footer"}}
    </div>
  </HdsCardContainer>
</template>;

export default Card;
